import Skeleton from '@material-ui/lab/Skeleton'
import React from 'react'

export default function SkeletonComponent(): JSX.Element {
  return <Skeleton variant="rect" height="100vh" width="100%" />
}
